import { render, staticRenderFns } from "./UserMyReviewPage.vue?vue&type=template&id=49872350&"
import script from "./UserMyReviewPage.vue?vue&type=script&lang=js&"
export * from "./UserMyReviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports